export default __webpack_public_path__ + "static/media/ex_img_05.3241c476.png";